import styled from 'styled-components';

export const SaveButtonsContainer = styled.div`
	padding-bottom: 10px;
	padding-top: 24px;
	text-align: center;
	width: 100%;
	@media (max-width: 768px) {
		padding: 14px;
	}
`;
